export default __webpack_public_path__ + "assets/10n.6a1e50d9.svg";